__turbopack_context__.v({
  "Active": "ProjectCategories-module-sass-module__aV7RUG__Active",
  "ProjectCategories": "ProjectCategories-module-sass-module__aV7RUG__ProjectCategories",
  "ProjectCategoriesSelect": "ProjectCategories-module-sass-module__aV7RUG__ProjectCategoriesSelect",
  "ProjectCategory": "ProjectCategories-module-sass-module__aV7RUG__ProjectCategory",
});
